webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(6)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(9),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(1);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#app',
  render: function render(h) {
    return h(_App2.default);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMark = __webpack_require__(8);

var _vueMark2 = _interopRequireDefault(_vueMark);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { VueMark: _vueMark2.default },
  data: function data() {
    return {
      githubLink: 'https://github.com/excaliburhan/vue-mark',
      val1: 3,
      val2: 108,
      code1: '<vue-mark :value="12">\n  <button>\u8BC4\u8BBA</button>\n</vue-mark>\n\n<vue-mark v-model="val1">\n  <button>\u56DE\u590D</button>\n</vue-mark>\n',
      code2: '<vue-mark :value="12" :max="10">\n  <button>\u8BC4\u8BBA</button>\n</vue-mark>\n\n<vue-mark v-model="val2" :max="99">\n  <button>\u56DE\u590D</button>\n</vue-mark>\n',
      code3: '<vue-mark :value="\'new\'">\n  <button>\u8BC4\u8BBA</button>\n</vue-mark>\n\n<vue-mark :value="\'hot\'">\n  <button>\u56DE\u590D</button>\n</vue-mark>',
      code4: '<vue-mark :value="12" :is-dot="true">\n  <button>\u8BC4\u8BBA</button>\n</vue-mark>\n\n<vue-mark :value="108">\n  <i></i>\n</vue-mark>'
    };
  }
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'vue-mark',
  props: {
    value: '',
    max: Number,
    isDot: Boolean,
    hidden: Boolean
  },
  computed: {
    content: function content() {
      if (this.isDot) return;
      var value = this.value;
      var max = this.max;

      if (typeof value === 'number' && typeof max === 'number') {
        return max < value ? max + '+' : value;
      }

      return value;
    }
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(7)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(10),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ca9bd748",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('a', {
    staticClass: "github-corner",
    attrs: {
      "href": _vm.githubLink,
      "aria-label": "View source on Github"
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "#70B7FD",
      "color": "#fff",
      "position": "absolute",
      "top": "0",
      "border": "0",
      "right": "0"
    },
    attrs: {
      "width": "80",
      "height": "80",
      "viewBox": "0 0 250 250",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"
    }
  }), _c('path', {
    staticClass: "octo-arm",
    staticStyle: {
      "transform-origin": "130px 106px"
    },
    attrs: {
      "d": "M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2",
      "fill": "currentColor"
    }
  }), _c('path', {
    staticClass: "octo-body",
    attrs: {
      "d": "M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), _c('h1', [_vm._v("Vue Mark")]), _vm._v(" "), _c('div', {
    staticClass: "app-wrap"
  }, [_c('div', {
    staticClass: "app-item"
  }, [_c('h2', [_vm._v("基础用法")]), _vm._v(" "), _c('vue-mark', {
    staticClass: "app-item__eg1",
    attrs: {
      "value": 12
    }
  }, [_c('span', {
    staticClass: "app-item__btn"
  }, [_vm._v("评论")])]), _vm._v(" "), _c('vue-mark', {
    staticClass: "app-item__eg1",
    model: {
      value: (_vm.val1),
      callback: function($$v) {
        _vm.val1 = $$v
      },
      expression: "val1"
    }
  }, [_c('span', {
    staticClass: "app-item__btn"
  }, [_vm._v("回复")])]), _vm._v(" "), _c('pre', {
    staticClass: "app-item__code"
  }, [_c('code', {
    staticClass: "html"
  }, [_vm._v(_vm._s(_vm.code1))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "app-item"
  }, [_c('h2', [_vm._v("最大值")]), _vm._v(" "), _c('vue-mark', {
    staticClass: "app-item__eg1",
    attrs: {
      "value": 12,
      "max": 10
    }
  }, [_c('span', {
    staticClass: "app-item__btn"
  }, [_vm._v("评论")])]), _vm._v(" "), _c('vue-mark', {
    staticClass: "app-item__eg1",
    attrs: {
      "max": 99
    },
    model: {
      value: (_vm.val2),
      callback: function($$v) {
        _vm.val2 = $$v
      },
      expression: "val2"
    }
  }, [_c('span', {
    staticClass: "app-item__btn"
  }, [_vm._v("回复")])]), _vm._v(" "), _c('pre', {
    staticClass: "app-item__code"
  }, [_c('code', {
    staticClass: "html"
  }, [_vm._v(_vm._s(_vm.code2))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "app-item"
  }, [_c('h2', [_vm._v("自定义文本")]), _vm._v(" "), _c('vue-mark', {
    staticClass: "app-item__eg1",
    attrs: {
      "value": 'new'
    }
  }, [_c('span', {
    staticClass: "app-item__btn"
  }, [_vm._v("评论")])]), _vm._v(" "), _c('vue-mark', {
    staticClass: "app-item__eg1",
    attrs: {
      "value": 'hot'
    }
  }, [_c('span', {
    staticClass: "app-item__btn"
  }, [_vm._v("回复")])]), _vm._v(" "), _c('pre', {
    staticClass: "app-item__code"
  }, [_c('code', {
    staticClass: "html"
  }, [_vm._v(_vm._s(_vm.code3))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "app-item"
  }, [_c('h2', [_vm._v("小红点")]), _vm._v(" "), _c('vue-mark', {
    staticClass: "app-item__eg1",
    attrs: {
      "value": '12',
      "is-dot": true
    }
  }, [_c('span', {
    staticClass: "app-item__btn"
  }, [_vm._v("评论")])]), _vm._v(" "), _c('vue-mark', {
    staticClass: "app-item__eg1",
    attrs: {
      "value": '12',
      "is-dot": true
    }
  }, [_c('span', {
    staticClass: "app-item__btn"
  }, [_vm._v("☛")])]), _vm._v(" "), _c('pre', {
    staticClass: "app-item__code"
  }, [_c('code', {
    staticClass: "html"
  }, [_vm._v(_vm._s(_vm.code4))])])], 1), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-item"
  }, [_c('h2', [_vm._v("参数")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', [_vm._v("显示值")]), _vm._v(" "), _c('td', [_vm._v("string, number")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("max")]), _vm._v(" "), _c('td', [_vm._v("最大值，超过最大值会显示 '{max}+'，要求 value 是 Number 类型")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("is-dot")]), _vm._v(" "), _c('td', [_vm._v("小圆点")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("hidden")]), _vm._v(" "), _c('td', [_vm._v("隐藏标识")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("false")])])])])])
}]}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-mark"
  }, [_vm._t("default"), _vm._v(" "), _c('sup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidden && (_vm.content || _vm.isDot)),
      expression: "!hidden && (content || isDot)"
    }],
    staticClass: "vue-mark__content",
    class: {
      'is-dot': _vm.isDot
    }
  }, [_vm._v(_vm._s(_vm.content))])], 2)
},staticRenderFns: []}

/***/ })
],[3]);


// WEBPACK FOOTER //
// static/js/app.edfba761b370f9dc9a48.js